module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/marketprices/addeditmarketprices/addeditmarketprices.component.css
// module id = ./src/app/marketprices/addeditmarketprices/addeditmarketprices.component.css
// module chunks = main